import request from './request'
import * as http from '@/libs/http'

/**
 * 指定条件の基本料金やオプション日数などを算出する
 *
 * @param {Number} shopid 店舗ID
 * @param {String} begin 予約開始日
 * @param {String} end 予約終了日
 * @param {Number} carid 車両ID
 * @returns {Response} レスポンスデータ
 */
export function getPeriod (shopid, begin, end, carid, rid, uid) {
  return request.get(`/shops/${shopid}/period`, {
    params: {
      s: begin,
      e: end,
      carid: carid,
      rid: rid,
      uid: uid
    },
    validateStatus: (status) => [
      http.OK,
      http.NoContent,
      http.Forbidden,
      http.Conflict
    ].includes(status)
  })
}
